import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';

export const StyledCheckbox = styled(Checkbox)`
  padding: 0.5px;
`;
